/**
 * 파일 저장 유틸.
 *
 * 서버가 파일을 남기지 않고 **응답 본문에 실어** 내려주므로, 받은 바이트를 그대로 저장한다 —
 * 다운로드 URL 을 열지 않으니 관리자 토큰 뒤에서만 파일이 나간다.
 */
const XLSX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

function downloadBlob(fileName: string, blob: Blob): void {
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement("a")

  anchor.href = objectUrl
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()

  // 브라우저가 저장을 시작한 뒤에 해제한다 — 즉시 해제하면 저장이 취소되는 브라우저가 있다
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
}

/**
 * 바이트를 파일로 저장한다
 *
 * `Uint8Array` 의 버퍼는 타입상 `SharedArrayBuffer` 일 수도 있어 `Blob` 이 받지 않는다 —
 * `ArrayBuffer` 로 한 번 복사해 넘긴다.
 */
function downloadBytes(
  fileName: string,
  bytes: Uint8Array,
  mimeType: string,
): void {
  const buffer = new ArrayBuffer(bytes.byteLength)
  new Uint8Array(buffer).set(bytes)

  downloadBlob(fileName, new Blob([buffer], { type: mimeType }))
}

export { XLSX_MIME_TYPE, downloadBlob, downloadBytes }
